import classNames from 'classnames';
import React from 'react';
import { useLocale } from '../../services/i18n/useLocale';
import { getProductUrl } from '../../utils';
import HtmlRenderer from '../common/Html';
import MagicLink from '../link';
import ProductItem from './ProductItem';

import { Wrapper, Table } from './Table.styles';
import trads from './trads';

const ProductTable = ({
  labels = [],
  columns = [],
  currentProductText = '',
  displayFrom = true,
  showStock = false,
}) => {
  const intl = useLocale();
  if (!labels?.length || !columns.length) {
    return null;
  }

  // columns = columns.splice(0, 3);

  return (
    <Wrapper>
      <Table className={`child-${columns?.length}`}>
        <thead>
          <tr>
            <th>&nbsp;</th>
            {columns.map((col) => (
              <th
                key={col.product.id}
                className={classNames({
                  'red-border': col.current,
                })}
              >
                {col.current ? (
                  <div className="current-prefix">{currentProductText}</div>
                ) : (
                  <div className="current-prefix empty">&nbsp;</div>
                )}
                <ProductItem
                  className="product"
                  {...col.product}
                  displayFrom={displayFrom}
                  largeDisplay
                  showStock={showStock}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="label"></td>
            {columns.map((col) => (
              <td
                key={col.product.id}
                className={classNames({
                  'red-border': col.current,
                })}
              >
                <MagicLink
                  href={getProductUrl(
                    col.product.handle,
                    intl.locale,
                    col.product.defaultVariant
                  )}
                  className={classNames(`simple-link more`, {
                    'block white': col.current,
                    red: !col.current,
                  })}
                >
                  {intl.formatMessage(trads.viewMore)}
                </MagicLink>
              </td>
            ))}
          </tr>
          {labels.map((row, index) => (
            <tr key={row.label}>
              <td className="label">{row.label}</td>
              {columns.map((col) => (
                <td
                  key={col.product.id}
                  className={classNames({
                    'highlight red-border': col.current,
                  })}
                >
                  <HtmlRenderer html={col.rows[index]?.html} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default ProductTable;
